import React from 'react';
import { Book, Briefcase, DatabaseLock, GlobeAsiaAustralia, LightningCharge, ShieldLock } from 'react-bootstrap-icons';
import aws from '../Assets/Images/companies/aws.svg';
import atlassian from '../Assets/Images/companies/atlassian.svg';
import ford from '../Assets/Images/companies/ford.svg';
import otto from '../Assets/Images/companies/otto.png';
import publicis from '../Assets/Images/companies/publicis-sapient.svg';
import waterloo from '../Assets/Images/companies/waterloo.png';
import superLogo from '../Assets/Images/companies/super.png';

const companyMarks = { aws, atlassian, ford, otto, publicis, super: superLogo, 'waterloo-education': waterloo };

const subjectMarks = {
  'waterloo-research': DatabaseLock,
  'vector-research': ShieldLock,
  watai: LightningCharge,
  ib: Book,
  olevels: GlobeAsiaAustralia,
};

export const ExperienceMark = ({ item }) => {
  const logo = companyMarks[item.id];
  const Icon = subjectMarks[item.id] || Briefcase;
  return (
    <div className={`experience-mark experience-mark-${item.category} experience-mark-${item.id}${logo ? ' experience-mark-brand' : ''}`} aria-hidden="true">
      {logo ? <img src={logo} alt="" width="36" height="36" /> : <Icon focusable="false" />}
    </div>
  );
};
